export default Object.freeze({
  400: 'Request could not be processed. Please check your form fields and try again.',
});
